import {FC, useState} from 'react'
import CheckBox from "../common/Checkbox/Checkbox";
import TireShopOpen from "../common/TireShop/TireShopOpen";
import {hjulskifteFlows, settings, site} from "../../constants/global";

interface Props {
    booking:Booking,
    setBooking:Function
}

const Tire: FC<Props> = ({booking, setBooking}) => {
    const [storeYes, setStoreYes] = useState(booking.tires.store === 'yes');
    const [storeNo, setStoreNo] = useState(booking.tires.store === 'no');
    const [dimensionText, setDimensionText] = useState(booking.tires.dimension);

    let service;

    for(let i=0; i<booking.serviceArray.length; i++) {
       service = booking.serviceArray[i]
        if(hjulskifteFlows.includes(service.booking_flow)) {
            service.meta.hotel_text = service.meta.hotel_text ? service.meta.hotel_text.replace("%price%", service.meta.price_inc_hotel) : '';
            break;
        }
    }

    const updateDimensionText = (e: any) => {
        setDimensionText(e.target.value)
        booking.tires.dimension = e.target.value
        setBooking({
            ...booking,
        })
    }

    const handleCheckBox = (box:string, value:any) => {
         switch (box) {
            case 'store_yes':
                booking.tires.store = 'yes'
                setStoreYes(value)
                setStoreNo(!value)
                // TODO Add däckhotell to cart
                break;
            case 'store_no':
                booking.tires.store = 'no'
                setStoreYes(!value)
                setStoreNo(value)
                // TODO Remove däckhotell from cart
                break;
            case 'stored_yes':
                booking.tires.stored = true
                break;
            case 'stored_no':
                booking.tires.stored = false
                break;
            case 'offer':
                booking.tires.send_offer = value
                break;
        }
        setBooking({
            ...booking,
        })
    }
    return (
        <>
            <div className={"radio-group"}>
                <ul className="wco-order-options_list mb-5">
                    <li>
                        <div className="li-text wco-options-group hjulskifte" data-cat="hjulskifte"
                             data-select="multi_select" data-cat-name="Hjulskifte">
                            <div className="wco-options-hjulskifte">
                                <div className="product-hotel">
                                    <h3>Lägg till däckhotell</h3>
                                    <span className="required"/>
                                    <div className="product-hotel-container">
                                        <div className="product-hotel-container-content">
                                            <div>{service.meta.hotel_text}</div>
                                            <div className={"product-hotel-container_choice"}>
                                                <CheckBox radio={true} title={'Ja tack'} active={storeYes} type={'store_yes'} handle={handleCheckBox} />
                                                <CheckBox radio={true} title={'Nej tack'} active={storeNo} type={'store_no'} handle={handleCheckBox}/>
                                            </div>
                                        </div>
                                        <div className="product-hotel-container-image">
                                            <div className="wco-info">
                                                <i className="far fa-info-circle" aria-hidden="true"/>
                                                <div className="wco-info-tooltip">{service.meta.hotel_tooltip}</div>
                                            </div>
                                            <img src={`${settings.url}/storage/images/tire.png`}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="li-text wco-options-group hjulskifte" data-cat="hjulskifte"
                             data-select="multi_select" data-cat-name="Hjulskifte">
                            <div className="wco-options-hjulskifte">
                                <div className="product-hotel">
                                    <h3>Mina däck</h3>
                                    <p>För att kunna förbereda inför ditt besök behöver vi veta var de hjul du ska
                                        byta till finns.
                                        Vi kan även erbjuda nya däck vid behov.</p>
                                    <span className="required"/>
                                    <CheckBox radio={true} title={'Jag har mina däck förvarade hos Mechanum'} active={booking.tires.stored} type={'stored_yes'} handle={handleCheckBox} />
                                    <CheckBox radio={true} title={'Jag tar med mig däcken själv'} active={!booking.tires.stored} type={'stored_no'} handle={handleCheckBox} />
                                </div>
                            </div>
                        </div>
                        <div className="li-text wco-options-group hjulskifte" data-cat="hjulskifte"
                             data-select="multi_select" data-cat-name="Hjulskifte">
                            <div className="wco-options-hjulskifte">
                                <div className="product-hotel">
                                    <h3>Prisförslag däck</h3>
                                    <CheckBox title={'Jag önskar prisförslag på nya däck'} active={booking.tires.send_offer} type={'offer'} handle={handleCheckBox}/>
                                </div>
                                {booking.tires.send_offer ? (
                                    <div className="input-outer mt-3" id="tire_ask_dimension_div">
                                        <label>Däckdimension <abbr className="required" title="krävs">*</abbr></label>
                                        <input id="tire_ask_dimension" type="text" name="tire_ask_dimension" placeholder="Ange dimension t ex 195/65R15" value={dimensionText} onChange={updateDimensionText} />
                                    </div>
                                ):('')}

                            </div>
                        </div>
                        <TireShopOpen booking={booking} setBooking={setBooking} />
                    </li>
                </ul>
            </div>
        </>
    )
};

export default Tire
